import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { env } from 'config';

const firebase = initializeApp({
  apiKey: env.FIREBASE_API_KEY,
  authDomain: env.FIREBASE_AUTH_DOMAIN,
  databaseURL: env.FIREBASE_DATABASE_URL,
  projectId: env.FIREBASE_PROJECT_ID,
  storageBucket: env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID,
  appId: env.FIREBASE_APP_ID,
});

export const messaging = getMessaging(firebase);

export const requestForToken = () =>
  new Promise<string>((resolve, reject) =>
    getToken(messaging, { vapidKey: env.FIREBASE_VAPID_KEY })
      .then(async (token) => {
        if (token) resolve(token);
        else console.log('No registration token available. Request permission to generate one.');
      })
      .catch(reject),
  );
